/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  PlacementInput,
  PlacementInput$Outbound,
  PlacementInput$outboundSchema,
} from "./placementinput.js";

export type SaveDashboardLayoutRequestBody = {
  /**
   * The dashboard to lay out
   */
  id: string;
  /**
   * Every card and where it sits; a dashboard holds at most 100
   */
  placements: Array<PlacementInput>;
};

/** @internal */
export type SaveDashboardLayoutRequestBody$Outbound = {
  id: string;
  placements: Array<PlacementInput$Outbound>;
};

/** @internal */
export const SaveDashboardLayoutRequestBody$outboundSchema: z.ZodMiniType<
  SaveDashboardLayoutRequestBody$Outbound,
  SaveDashboardLayoutRequestBody
> = z.object({
  id: z.string(),
  placements: z.array(PlacementInput$outboundSchema),
});

export function saveDashboardLayoutRequestBodyToJSON(
  saveDashboardLayoutRequestBody: SaveDashboardLayoutRequestBody,
): string {
  return JSON.stringify(
    SaveDashboardLayoutRequestBody$outboundSchema.parse(
      saveDashboardLayoutRequestBody,
    ),
  );
}
